
  
<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-btn @click="$emit('on-submit', listItems)" class="primary" large>{{
          $t("button.save")
        }}</v-btn>
      </v-col>
      <v-col col="12" lg="6" class="mx-auto" v-if="listItems.length > 0">
        <draggable
          class="list-group"
          tag="ul"
          v-model="listItems"
          v-bind="dragOptions"
          @start="isDragging = true"
          @end="isDragging = false"
        >
          <transition-group type="transition" name="flip-list">
            <v-list-item
              v-for="item in listItems"
              :key="item.id"
              class="list-group-item"
            >
              <v-list-item-content
                class="mb-4"
                style="background-color: #444; color: #fff; border-radius: 8px"
              >
                <v-list-item-title class="px-2">
                  {{ item.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </transition-group>
        </draggable>
      </v-col>
      <Loader v-else />
    </v-row>
  </v-container>
</template>

<script>
import draggable from "vuedraggable";
import { IndexData } from "@/helpers/apiMethods";

export default {
  name: "DraggableWrapper",
  props: {
    reqName: {
      type: String,
      default: "",
    },
    priorityPath: {
      type: String,
      default: "",
    },
  },

  components: {
    draggable,
  },
  data() {
    return {
      listItems: [],
    };
  },
  methods: {
    getItems() {
      IndexData({
        reqName: `admin-panel/${this.reqName}`,
        query: { pagination: "all", ...this.$route.query },
      }).then((res) => {
        const { data } = res.data;
        this.listItems = data;
      });
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  watch: {
    $route: {
      handler() {
        this.getItems();
      },
      immediate: true,
    },
  },
};
</script>

<style>
.button {
  margin-top: 35px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>